import {getDateTimeAndTimezone} from '@vio/core/src/offer/business/cancellationPenalties'
import {convertToDifferentTimeZone} from '@vio/core/src/utils/date'

export const NUMBER_OF_DECIMALS_FOR_PRICE = 2

const getPenaltyDate = (date: string, hotelTimeZone?: string) => {
  return hotelTimeZone ? convertToDifferentTimeZone(date, hotelTimeZone) : date
}

export const getPenaltyDateTime = (date: string, hotelTimeZone?: string) => {
  const penaltyDate = getPenaltyDate(date, hotelTimeZone)
  return getDateTimeAndTimezone(penaltyDate)
}

export const currencyConsistentChecker = (
  currency: string,
  displayCurrencyCode: string
) => currency === displayCurrencyCode
